<template>
    <on-click-outside :do="hide">
        <div @click="show">
            <slot />
            <popout
                v-if="expanded"
                :placement="placement"
                :dropdown-class="dropdownClass"
                @hide="showResults = false"
            >
                <slot name="dropdown" />
            </popout>
        </div>
    </on-click-outside>
</template>

<script>
    import Popout from './Popout';

    export default {
        components: {
            Popout,
        },
        props: {
            placement: {
                required: false,
                type: String,
                default: 'auto',
            },
            dropdownClass: {
                required: false,
                type: String,
                default: '',
            },
        },
        data() {
            return {
                expanded: false,
            };
        },
        methods: {
            show() {
                this.expanded = ! this.expanded;
            },
            hide() {
                this.expanded = false;
            },
        },
    };
</script>